import { Entity, Field } from "typegraph";

import ProgramProgress from "./ProgramProgress";
import ProgramTrackProduct from "./ProgramTrackProduct";

@Entity({one: "programTrack", many: "programTracks"})
export default class ProgramTrack {

	@Field()
	public id: string;

	@Field()
	public name: string;

	@Field()
	public description: string;

	@Field()
	public entryCount: number;

	@Field()
	public trackIconURL: string;

	@Field({entity: ProgramProgress})
	public progress: ProgramProgress;

	@Field({entity: ProgramTrackProduct})
	public products: ProgramTrackProduct[];

}



// WEBPACK FOOTER //
// ./src/panels/tracksProgram/entities/ProgramTrack.ts